import { ColDef } from 'ag-grid-community';

export const FFLLookupColumnDef: ColDef[] = [
  {
    // FFL Number
    headerName: 'FFL Number',
    field: 'ffl_number',
    valueFormatter: (params) => {
      const value = (params.value ?? '').toString();
      if (value.length !== 15) return value;
      return `${value.slice(0, 1)}-${value.slice(1, 3)}-${value.slice(3, 6)}-${value.slice(6, 8)}-${value.slice(8, 10)}-${value.slice(10, 15)}`;
    },
    resizable: true,
    width: 190,
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // License Name
    headerName: 'License Name',
    field: 'license_name',
    resizable: true,
    width: 275,
    tooltipField: 'license_name',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Business Name
    headerName: 'Business Name',
    field: 'business_name',
    resizable: true,
    width: 275,
    tooltipField: 'business_name',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Premise Street
    headerName: 'Premise Street',
    field: 'premise_street',
    resizable: true,
    width: 250,
    tooltipField: 'premise_street',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Premise City
    headerName: 'Premise City',
    field: 'premise_city',
    resizable: true,
    width: 140,
    tooltipField: 'premise_city',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Premise State
    headerName: 'Premise State',
    field: 'premise_state',
    resizable: true,
    width: 120,
    tooltipField: 'premise_state',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Premise Zip Code
    headerName: 'Premise Zip',
    field: 'premise_zip_code',
    valueFormatter: (params) => {
      const value = (params.value ?? '').toString().trim();
      if (value.length === 9) {
        return `${value.slice(0, 5)}-${value.slice(5, 9)}`;
      }
      return value;
    },
    resizable: true,
    width: 140,
    tooltipField: 'premise_zip_code',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Mailing Street
    headerName: 'Mailing Street',
    field: 'mailing_street',
    resizable: true,
    width: 250,
    tooltipField: 'mailing_street',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Mailing City
    headerName: 'Mailing City',
    field: 'mailing_city',
    resizable: true,
    width: 140,
    tooltipField: 'mailing_city',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Mailing State
    headerName: 'Mailing State',
    field: 'mailing_state',
    resizable: true,
    width: 120,
    tooltipField: 'mailing_state',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Mailing Zip Code
    headerName: 'Mailing Zip',
    field: 'mailing_zip_code',
    valueFormatter: (params) => {
      const value = (params.value ?? '').toString().trim();
      if (value.length === 9) {
        return `${value.slice(0, 5)}-${value.slice(5, 9)}`;
      }
      return value;
    },
    resizable: true,
    width: 140,
    tooltipField: 'mailing_zip_code',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // Voice Telephone
    headerName: 'Phone',
    field: 'voice_telephone',
    valueFormatter: (params) => {
      const value = (params.value ?? '').toString().replace(/\D/g, '');
      if (value.length === 10) {
        return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6)}`;
      }
      return params.value;
    },
    resizable: true,
    width: 150,
    tooltipField: 'voice_telephone',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // LOA Issue Date
    headerName: 'LOA Issue Date',
    field: 'loa_issue_date',
    valueFormatter: (params) => {
      const value = (params.value ?? '').toString().trim();
      if (value.length === 8) {
        return `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
      }
      return value;
    },
    resizable: true,
    width: 150,
    tooltipField: 'loa_issue_date',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
  {
    // LOA Expiration Date
    headerName: 'LOA Expiration Date',
    field: 'loa_expiration_date',
    valueFormatter: (params) => {
      const value = (params.value ?? '').toString().trim();
      if (value.length === 8) {
        return `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
      }
      return value;
    },
    resizable: true,
    width: 170,
    tooltipField: 'loa_expiration_date',
    filter: 'agTextColumnFilter',
    filterParams: { defaultOption: 'startsWith' },
  },
];
